import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0ecfac5e")

_pushScopeId("data-v-0ecfac5e")
const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = { class: "p-col" }
const _hoisted_3 = {
  class: "box p-p-2 p-d-flex p-flex-column",
  style: {"height":"100%"}
}
const _hoisted_4 = { class: "summary-title" }
const _hoisted_5 = {
  key: 0,
  class: "summary-description"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = { class: "summary-footer p-mt-auto" }
const _hoisted_8 = { class: "p-col" }
const _hoisted_9 = { class: "box p-p-2 p-d-flex p-flex-column" }
const _hoisted_10 = { class: "summary-title" }
const _hoisted_11 = {
  key: 0,
  class: "summary-description"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = { class: "summary-footer p-mt-auto" }
const _hoisted_14 = { class: "box p-p-2 p-d-flex p-flex-column" }
const _hoisted_15 = { class: "summary-title" }
const _hoisted_16 = { class: "kpi-value" }
const _hoisted_17 = { class: "summary-footer p-mt-auto" }
const _hoisted_18 = { class: "p-grid" }
const _hoisted_19 = { class: "p-col-6 p-col-sm-12" }
const _hoisted_20 = { class: "p-grid p-nogutter" }
const _hoisted_21 = { class: "p-col-6 p-p-1" }
const _hoisted_22 = { class: "p-text-secondary" }
const _hoisted_23 = { class: "p-col-6 p-p-1" }
const _hoisted_24 = { class: "p-col-6 p-p-1" }
const _hoisted_25 = { class: "p-text-secondary" }
const _hoisted_26 = { class: "p-col-6 p-p-1" }
const _hoisted_27 = { class: "p-col-6 p-p-1" }
const _hoisted_28 = { class: "p-text-secondary" }
const _hoisted_29 = { class: "p-col-6 p-p-1" }
const _hoisted_30 = { class: "p-col-6 p-p-1" }
const _hoisted_31 = { class: "p-text-secondary" }
const _hoisted_32 = { class: "p-col-6 p-p-1" }
const _hoisted_33 = { class: "p-text-bold" }
const _hoisted_34 = { class: "p-col-6 p-p-1" }
const _hoisted_35 = { class: "p-text-secondary" }
const _hoisted_36 = { class: "p-col-6 p-p-1" }
const _hoisted_37 = { class: "p-text-bold" }
const _hoisted_38 = { class: "p-col-6 p-p-1" }
const _hoisted_39 = { class: "p-text-secondary" }
const _hoisted_40 = { class: "p-col-6 p-p-1" }
const _hoisted_41 = { class: "p-text-bold" }
const _hoisted_42 = { class: "p-col-6 p-col-sm-12" }
const _hoisted_43 = { class: "p-grid p-nogutter" }
const _hoisted_44 = { class: "p-col-6 p-p-1" }
const _hoisted_45 = { class: "p-text-secondary" }
const _hoisted_46 = { class: "p-col-6 p-p-1 p-text-bold" }
const _hoisted_47 = { class: "p-col-6 p-p-1" }
const _hoisted_48 = { class: "p-text-secondary" }
const _hoisted_49 = { class: "p-col-6 p-p-1" }
const _hoisted_50 = { class: "p-text-bold" }
const _hoisted_51 = { class: "p-col-6 p-p-1" }
const _hoisted_52 = { class: "p-text-secondary" }
const _hoisted_53 = { class: "p-col-6 p-p-1" }
const _hoisted_54 = { class: "p-text-bold" }
const _hoisted_55 = { class: "p-col-6 p-p-1" }
const _hoisted_56 = { class: "p-text-secondary" }
const _hoisted_57 = { class: "p-col-6 p-p-1" }
const _hoisted_58 = { class: "p-text-bold" }
const _hoisted_59 = { class: "p-col-6 p-p-1" }
const _hoisted_60 = { class: "p-text-secondary" }
const _hoisted_61 = { class: "p-col-6 p-p-1" }
const _hoisted_62 = { class: "p-text-bold" }
const _hoisted_63 = { class: "p-col-6 p-p-1" }
const _hoisted_64 = { class: "p-text-secondary" }
const _hoisted_65 = { class: "p-col-6 p-p-1" }
const _hoisted_66 = { class: "p-text-bold" }
const _hoisted_67 = { class: "p-col-6 p-p-1" }
const _hoisted_68 = { class: "p-text-secondary" }
const _hoisted_69 = { class: "p-col-6 p-p-1 p-text-bold" }
const _hoisted_70 = { class: "p-col-6 p-p-1" }
const _hoisted_71 = { class: "p-text-secondary" }
const _hoisted_72 = { class: "p-col-6 p-p-1 p-text-bold" }
const _hoisted_73 = { class: "p-mt-0" }
const _hoisted_74 = { class: "p-grid" }
const _hoisted_75 = { class: "p-col-6 p-col-sm-12" }
const _hoisted_76 = { class: "p-grid p-nogutter" }
const _hoisted_77 = { class: "p-col-6 p-p-1" }
const _hoisted_78 = { class: "p-text-secondary" }
const _hoisted_79 = { class: "p-col-6 p-p-1" }
const _hoisted_80 = { class: "p-text-bold" }
const _hoisted_81 = { class: "p-col-6 p-p-1" }
const _hoisted_82 = { class: "p-text-secondary" }
const _hoisted_83 = { class: "p-col-6 p-p-1" }
const _hoisted_84 = { class: "p-text-bold" }
const _hoisted_85 = { class: "p-col-6 p-col-sm-12" }
const _hoisted_86 = { class: "p-grid p-nogutter" }
const _hoisted_87 = { class: "p-col-6 p-p-1" }
const _hoisted_88 = { class: "p-text-secondary" }
const _hoisted_89 = { class: "p-col-6 p-p-1 p-text-bold" }
const _hoisted_90 = { key: 0 }
const _hoisted_91 = { key: 1 }
const _hoisted_92 = { key: 2 }
const _hoisted_93 = { class: "p-col-6 p-p-1" }
const _hoisted_94 = { class: "p-text-secondary" }
const _hoisted_95 = { class: "p-col-6 p-p-1 p-text-bold" }
const _hoisted_96 = {
  key: 0,
  class: "p-col-12 p-pt-0"
}
const _hoisted_97 = { class: "p-text-secondary p-p-1" }
const _hoisted_98 = { class: "p-d-flex p-jc-between" }
const _hoisted_99 = { class: "p-input-icon-left" }
const _hoisted_100 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_101 = {
  key: 0,
  class: "p-d-flex p-ai-center"
}
const _hoisted_102 = { class: "p-d-flex p-ai-center" }
const _hoisted_103 = { class: "p-pl-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Chip = _resolveComponent("Chip")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataRole = _resolveComponent("DataRole")!
  const _component_DataType = _resolveComponent("DataType")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Card, null, {
      title: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("autots.label.summary")), 1)
      ]),
      content: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("autots.label.datasource")), 1),
              (
                _ctx.datasourceConfig &&
                _ctx.datasourceConfigDetail &&
                _ctx.datasourceConfigDetail[_ctx.datasourceConfig.datasourceId]
              )
                ? (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(_ctx.datasourceConfigDetail[_ctx.datasourceConfig?.datasourceId].name), 1))
                : _createCommentVNode("", true),
              _hoisted_6,
              _createVNode("div", _hoisted_7, [
                (_ctx.datasourceConfig)
                  ? (_openBlock(), _createBlock("a", {
                      key: 0,
                      target: "_blank",
                      href: `/workspace/${_ctx.workspaceId}/datasource/${_ctx.datasourceConfig.datasourceId}/`
                    }, [
                      _createVNode(_component_Button, { class: "p-button-text" }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("autots.label.view_data")), 1)
                        ]),
                        _: 1
                      })
                    ], 8, ["href"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("autots.label.targetcolumn")), 1),
              (_ctx.datasourceConfig)
                ? (_openBlock(), _createBlock("div", _hoisted_11, _toDisplayString(_ctx.datasourceConfig.targetColumn), 1))
                : _createCommentVNode("", true),
              _hoisted_12,
              _createVNode("div", _hoisted_13, [
                _createVNode(_component_Button, {
                  label: _ctx.$t('autots.label.view_detail'),
                  class: "p-button-text",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSettingDialog = true))
                }, null, 8, ["label"])
              ])
            ])
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.metrics, ({ name, isPercentage }) => {
            return (_openBlock(), _createBlock("div", {
              class: "p-col",
              key: name
            }, [
              _createVNode("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, _toDisplayString(_ctx.$t(`label.metric.${name}`)), 1),
                _createVNode("div", _hoisted_16, _toDisplayString(_ctx.bestKpi[name]
                  ? isPercentage
                    ? _ctx.$toPercentage(_ctx.bestKpi[name]?.value, 1)
                    : _ctx.$toShortNumber(_ctx.bestKpi[name]?.value)
                  : "--"), 1),
                _createVNode("div", _hoisted_17, _toDisplayString(_ctx.bestKpi[name]?.algorithmId
                  ? _ctx.$t(`${_ctx.bestKpi[name]?.algorithmId}`)
                  : ""), 1)
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Dialog, {
      header: _ctx.$t('experiment.label.view_detail.title'),
      visible: _ctx.showSettingDialog,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.showSettingDialog = $event)),
      style: { width: '50vw' },
      modal: true
    }, {
      default: _withId(() => [
        _createVNode("h6", null, _toDisplayString(_ctx.$t("experiment.label.setting.basic")), 1),
        _createVNode("div", _hoisted_18, [
          _createVNode("div", _hoisted_19, [
            _createVNode("div", _hoisted_20, [
              (_ctx.datasourceConfig.targetColumn)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createVNode("div", _hoisted_21, [
                      _createVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("autots.label.targetcolumn")), 1)
                    ]),
                    _createVNode("div", _hoisted_23, [
                      _createVNode(_component_Chip, {
                        label: _ctx.datasourceConfig.targetColumn
                      }, null, 8, ["label"])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.datasourceConfig.timeSeriesColumn)
                ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _createVNode("div", _hoisted_24, [
                      _createVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("autots.label.timeseriescolumn")), 1)
                    ]),
                    _createVNode("div", _hoisted_26, [
                      _createVNode(_component_Chip, {
                        label: _ctx.datasourceConfig.timeSeriesColumn
                      }, null, 8, ["label"])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (
              _ctx.datasourceConfig.timeSeriesIdentifiers &&
              _ctx.datasourceConfig.timeSeries
            )
                ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                    _createVNode("div", _hoisted_27, [
                      _createVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("autots.label.IDCs")), 1)
                    ]),
                    _createVNode("div", _hoisted_29, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.datasourceConfig.timeSeriesIdentifiers, (column, index) => {
                        return (_openBlock(), _createBlock(_component_Chip, {
                          key: index,
                          label: column,
                          class: "p-mr-2"
                        }, null, 8, ["label"]))
                      }), 128))
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.experiment.config.forecastHorizon)
                ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                    _createVNode("div", _hoisted_30, [
                      _createVNode("span", _hoisted_31, _toDisplayString(_ctx.$t("autots.label.predictduration")), 1)
                    ]),
                    _createVNode("div", _hoisted_32, [
                      _createVNode("p", _hoisted_33, _toDisplayString(_ctx.experiment.config.forecastHorizon +
                  _ctx.$t(_ctx.getSuffix(_ctx.experiment.config.frequency))), 1)
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.experiment.config.predictionType)
                ? (_openBlock(), _createBlock(_Fragment, { key: 4 }, [
                    _createVNode("div", _hoisted_34, [
                      _createVNode("span", _hoisted_35, _toDisplayString(_ctx.$t("automl.create.header.prediction.type")), 1)
                    ]),
                    _createVNode("div", _hoisted_36, [
                      _createVNode("p", _hoisted_37, _toDisplayString(_ctx.$t(
                    `automl.create.header.prediction.type.${_ctx.experiment.config.predictionType}`
                  )), 1)
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.experiment.type == 'AUTOTS')
                ? (_openBlock(), _createBlock(_Fragment, { key: 5 }, [
                    _createVNode("div", _hoisted_38, [
                      _createVNode("span", _hoisted_39, _toDisplayString(_ctx.$t("autots.label.gap")), 1)
                    ]),
                    _createVNode("div", _hoisted_40, [
                      _createVNode("p", _hoisted_41, _toDisplayString(_ctx.experiment.config.gap +
                  _ctx.$t(_ctx.getSuffix(_ctx.experiment.config.frequency))), 1)
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_42, [
            _createVNode("div", _hoisted_43, [
              (
              _ctx.experiment.config.timeSeriesIdentifiers &&
              _ctx.experiment.config.timeSeriesIdentifiers.length
            )
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createVNode("div", _hoisted_44, [
                      _createVNode("span", _hoisted_45, _toDisplayString(_ctx.$t("autots.create.header.IDCs")), 1)
                    ]),
                    _createVNode("div", _hoisted_46, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.experiment.config
                  .timeSeriesIdentifiers, (column, index) => {
                        return (_openBlock(), _createBlock(_component_Chip, {
                          key: index,
                          label: column,
                          class: "p-mr-2 p-mb-2"
                        }, null, 8, ["label"]))
                      }), 128))
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.experiment.config.startDate)
                ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _createVNode("div", _hoisted_47, [
                      _createVNode("span", _hoisted_48, _toDisplayString(_ctx.$t("autots.label.start_date")), 1)
                    ]),
                    _createVNode("div", _hoisted_49, [
                      _createVNode("p", _hoisted_50, _toDisplayString(_ctx.$moment(_ctx.experiment.config.startDate).format("YYYY-MM-DD")), 1)
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.experiment.config.endDate)
                ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                    _createVNode("div", _hoisted_51, [
                      _createVNode("span", _hoisted_52, _toDisplayString(_ctx.$t("autots.label.end_date")), 1)
                    ]),
                    _createVNode("div", _hoisted_53, [
                      _createVNode("p", _hoisted_54, _toDisplayString(_ctx.$moment(_ctx.experiment.config.endDate).format("YYYY-MM-DD")), 1)
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (
              !_ctx.experiment.config.trainRatio &&
              _ctx.experiment.config.splitTrainStartDate &&
              _ctx.experiment.config.splitTrainEndDate
            )
                ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                    _createVNode("div", _hoisted_55, [
                      _createVNode("span", _hoisted_56, _toDisplayString(_ctx.$t("automl.create.header.train")), 1)
                    ]),
                    _createVNode("div", _hoisted_57, [
                      _createVNode("p", _hoisted_58, _toDisplayString(_ctx.$moment(_ctx.experiment.config.splitTrainStartDate).format(
                    "YYYY-MM-DD"
                  )) + " ~ " + _toDisplayString(_ctx.$moment(_ctx.experiment.config.splitTrainEndDate).format(
                    "YYYY-MM-DD"
                  )), 1)
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (
              !_ctx.experiment.config.trainRatio &&
              _ctx.experiment.config.splitTestStartDate &&
              _ctx.experiment.config.splitTestEndDate
            )
                ? (_openBlock(), _createBlock(_Fragment, { key: 4 }, [
                    _createVNode("div", _hoisted_59, [
                      _createVNode("span", _hoisted_60, _toDisplayString(_ctx.$t("automl.create.header.test")), 1)
                    ]),
                    _createVNode("div", _hoisted_61, [
                      _createVNode("p", _hoisted_62, _toDisplayString(_ctx.$moment(_ctx.experiment.config.splitTestStartDate).format(
                    "YYYY-MM-DD"
                  )) + " ~ " + _toDisplayString(_ctx.$moment(_ctx.experiment.config.splitTestEndDate).format(
                    "YYYY-MM-DD"
                  )), 1)
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.experiment.config.trainRatio)
                ? (_openBlock(), _createBlock(_Fragment, { key: 5 }, [
                    _createVNode("div", _hoisted_63, [
                      _createVNode("span", _hoisted_64, _toDisplayString(_ctx.$t("label.training_ratio")), 1)
                    ]),
                    _createVNode("div", _hoisted_65, [
                      _createVNode("p", _hoisted_66, _toDisplayString(_ctx.experiment.config.trainRatio) + "%", 1)
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_67, [
                _createVNode("span", _hoisted_68, _toDisplayString(_ctx.$t("label.primary_metric")), 1)
              ]),
              _createVNode("div", _hoisted_69, _toDisplayString(_ctx.$t(`label.metric.${_ctx.experiment.config.primaryMetric}`)), 1),
              _createVNode("div", _hoisted_70, [
                _createVNode("span", _hoisted_71, _toDisplayString(_ctx.$t("label.other_metrics")), 1)
              ]),
              _createVNode("div", _hoisted_72, _toDisplayString(_ctx.experiment.config.otherMetrics
                .map((t) => _ctx.$t(`label.metric.${t}`))
                .join(", ")), 1)
            ])
          ])
        ]),
        _createVNode("h6", _hoisted_73, _toDisplayString(_ctx.$t("experiment.label.setting.advanced")), 1),
        _createVNode("div", _hoisted_74, [
          _createVNode("div", _hoisted_75, [
            _createVNode("div", _hoisted_76, [
              (_ctx.experiment.config.modelList)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createVNode("div", _hoisted_77, [
                      _createVNode("span", _hoisted_78, _toDisplayString(_ctx.$t("autots.evaluation.summamy.model.list")), 1)
                    ]),
                    _createVNode("div", _hoisted_79, [
                      _createVNode("p", _hoisted_80, _toDisplayString(_ctx.experiment.config.modelList.map((x) => _ctx.$t(x)).join(", ")), 1)
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.experiment.config.timeLimit)
                ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _createVNode("div", _hoisted_81, [
                      _createVNode("span", _hoisted_82, _toDisplayString(_ctx.$t("automl.create.limit.time.label")), 1)
                    ]),
                    _createVNode("div", _hoisted_83, [
                      _createVNode("p", _hoisted_84, _toDisplayString(_ctx.$t(
                    `automl.create.limit.time.${
                      _ctx.experiment.config.timeLimit / 3600
                    }`
                  )), 1)
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_85, [
            _createVNode("div", _hoisted_86, [
              (_ctx.experiment.config.postProcessing)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createVNode("div", _hoisted_87, [
                      _createVNode("span", _hoisted_88, _toDisplayString(_ctx.$t("autots.create.advance.post.processing.range")), 1)
                    ]),
                    _createVNode("div", _hoisted_89, [
                      (
                  _ctx.experiment.config.postProcessing.trimRange.mode === 'auto'
                )
                        ? (_openBlock(), _createBlock("p", _hoisted_90, _toDisplayString(_ctx.$t("autots.create.advance.post.processing.range.auto")), 1))
                        : (
                  _ctx.experiment.config.postProcessing.trimRange.mode === 'manual'
                )
                          ? (_openBlock(), _createBlock("p", _hoisted_91, _toDisplayString(_ctx.$t("autots.evaluation.summamy.range.manual", {
                    min: _ctx.experiment.config.postProcessing.trimRange.min,
                    max: _ctx.experiment.config.postProcessing.trimRange.max,
                  })), 1))
                          : (_openBlock(), _createBlock("p", _hoisted_92, _toDisplayString(_ctx.$t("autots.create.advance.post.processing.range.no.setting")), 1))
                    ]),
                    _createVNode("div", _hoisted_93, [
                      _createVNode("span", _hoisted_94, _toDisplayString(_ctx.$t("autots.create.advance.round")), 1)
                    ]),
                    _createVNode("div", _hoisted_95, [
                      _createVNode("p", null, _toDisplayString(_ctx.$t(
                    _ctx.experiment.config.postProcessing.round
                      ? "autots.evaluation.summamy.round.yes"
                      : "autots.evaluation.summamy.round.no"
                  )), 1)
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.experiment.type == 'AUTOML')
            ? (_openBlock(), _createBlock("div", _hoisted_96, [
                _createVNode("span", _hoisted_97, _toDisplayString(_ctx.$t("automl.create.feature.label")), 1),
                _createVNode("div", null, [
                  _createVNode(_component_DataTable, {
                    value: 
              _ctx.datasourceConfigDetail[_ctx.datasourceConfig.datasourceId].schemas
            ,
                    responsiveLayout: "scroll",
                    rowClass: _ctx.rowClass,
                    filters: _ctx.filters,
                    "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = $event))
                  }, {
                    header: _withId(() => [
                      _createVNode("div", _hoisted_98, [
                        _createVNode("span", _hoisted_99, [
                          _hoisted_100,
                          _createVNode(_component_InputText, {
                            modelValue: _ctx.filters['global'].value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters['global'].value = $event)),
                            placeholder: _ctx.$t('automl.create.search')
                          }, null, 8, ["modelValue", "placeholder"])
                        ])
                      ])
                    ]),
                    empty: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("automl.create.not.found")), 1)
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_Column, {
                        field: "name",
                        header: _ctx.$t('automl.create.column.name')
                      }, null, 8, ["header"]),
                      _createVNode(_component_Column, {
                        field: "role",
                        header: _ctx.$t('automl.create.column.role')
                      }, {
                        body: _withId((slotProps) => [
                          (slotProps.data.role)
                            ? (_openBlock(), _createBlock("div", _hoisted_101, [
                                _createVNode(_component_DataRole, {
                                  role: slotProps.data.role
                                }, null, 8, ["role"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["header"]),
                      _createVNode(_component_Column, {
                        field: "type",
                        header: _ctx.$t('automl.create.column.type')
                      }, {
                        body: _withId((slotProps) => [
                          _createVNode("div", _hoisted_102, [
                            _createVNode(_component_DataType, {
                              dataType: slotProps.data.type
                            }, null, 8, ["dataType"]),
                            _createVNode("div", _hoisted_103, _toDisplayString(_ctx.$t(`datasource.datatype.${slotProps.data.type}`)), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["header"])
                    ]),
                    _: 1
                  }, 8, ["value", "rowClass", "filters"])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["header", "visible"])
  ], 64))
})